var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteeringImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 306,
    viewBox: "0 0 306 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.768 303.816C236.036 303.816 303.537 236.458 303.537 153.367C303.537 70.2768 236.036 2.91846 152.768 2.91846C69.5013 2.91846 2 70.2768 2 153.367C2 236.458 69.5013 303.816 152.768 303.816Z",
    stroke: "#0086FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.766 283.582C224.833 283.582 283.256 225.283 283.256 153.368C283.256 81.453 224.833 23.1543 152.766 23.1543C80.6978 23.1543 22.2754 81.453 22.2754 153.368C22.2754 225.283 80.6978 283.582 152.766 283.582Z",
    stroke: "#0086FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1408_143319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.112 188.167L154.359 187.257L145.61 188.167L140.154 228.395H154.359H168.566L163.112 188.167Z",
    fill: "#C0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.566 228.395L163.113 188.167L154.36 187.257L145.611 188.167L144.328 197.615C150.002 199.103 159.509 201.878 159.987 203.906C160.63 206.636 162.478 222.82 158.704 228.395H168.569H168.566Z",
    fill: "#5A91F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.557 195.929L164.883 201.241L163.112 188.167L154.359 187.257L145.61 188.167L144.557 195.929Z",
    fill: "#C0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.104 139.642C113.104 139.642 87.8751 140.666 84.4675 131.458C84.4675 131.458 75.9439 149.529 83.7855 167.598C83.7855 167.598 88.2172 153.936 113.104 155.653V139.642Z",
    fill: "#45A1EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9922 136.86C91.269 137.916 91.888 139.161 93.1619 140.495C96.0069 143.477 106.824 148.179 113.106 149.381V139.642C113.106 139.642 99.5743 140.187 90.9922 136.86Z",
    fill: "#1CB4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.104 155.654V151.051C112.989 151.055 112.879 151.058 112.764 151.064C87.1934 152.428 88.8972 146.462 88.8972 146.462C88.6406 144.733 89.3451 140.374 90.1036 136.498C87.3937 135.31 85.2893 133.687 84.4655 131.461C84.4655 131.461 75.9419 149.532 83.7835 167.6C83.7835 167.6 88.2153 153.939 113.102 155.656L113.104 155.654Z",
    fill: "#C0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.344 139.642C194.344 139.642 219.572 140.666 222.982 131.458C222.982 131.458 231.506 149.529 223.664 167.597C223.664 167.597 219.233 153.936 194.344 155.653V139.642Z",
    fill: "#45A1EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.457 136.86C216.181 137.915 215.562 139.16 214.288 140.495C211.443 143.477 200.628 148.179 194.344 149.38V139.642C194.344 139.642 207.875 140.186 216.457 136.86Z",
    fill: "#1CB4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.344 155.653V151.05C194.459 151.055 194.569 151.057 194.682 151.064C220.252 152.428 218.549 146.461 218.549 146.461C218.807 144.733 218.103 140.373 217.342 136.497C220.052 135.309 222.154 133.686 222.98 131.46C222.98 131.46 231.504 149.531 223.662 167.6C223.662 167.6 219.231 153.938 194.342 155.655L194.344 155.653Z",
    fill: "#C0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.359 68.3872C106.344 68.3872 67.4219 107.311 67.4219 155.325C67.4219 203.339 106.344 242.262 154.359 242.262C202.375 242.262 241.299 203.336 241.299 155.325C241.299 107.313 202.375 68.3872 154.359 68.3872ZM154.359 224.533C116.137 224.533 85.1533 193.546 85.1533 155.325C85.1533 117.103 116.137 86.1159 154.359 86.1159C192.582 86.1159 223.572 117.101 223.572 155.325C223.572 193.548 192.584 224.533 154.359 224.533Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.359 68.3872C106.344 68.3872 67.4219 107.311 67.4219 155.325C67.4219 203.339 106.344 242.262 154.359 242.262C202.375 242.262 241.299 203.336 241.299 155.325C241.299 107.313 202.375 68.3872 154.359 68.3872ZM154.359 224.533C116.137 224.533 85.1533 193.546 85.1533 155.325C85.1533 117.103 116.137 86.1159 154.359 86.1159C192.582 86.1159 223.572 117.101 223.572 155.325C223.572 193.548 192.584 224.533 154.359 224.533Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 78.6167C111.997 78.6167 77.6504 112.962 77.6504 155.325C77.6504 197.687 111.997 232.033 154.36 232.033C196.724 232.033 231.073 197.69 231.073 155.325C231.073 112.96 196.729 78.6167 154.36 78.6167ZM154.36 224.534C116.138 224.534 85.1544 193.546 85.1544 155.325C85.1544 117.104 116.138 86.116 154.36 86.116C192.583 86.116 223.573 117.101 223.573 155.325C223.573 193.548 192.585 224.534 154.36 224.534Z",
    fill: "#2899FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.721 137.711V157.256L143.451 190.895H165.272L198.003 157.256V137.711C181.829 132.318 126.892 132.318 110.721 137.711Z",
    fill: "#C0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.993 141.015C166.428 141.488 165.841 141.789 165.297 142.155C163.103 143.629 160.901 145.096 158.696 146.559C158.368 146.776 158.484 146.964 158.696 147.152C159.499 147.866 160.301 148.58 161.106 149.286C161.537 149.666 161.975 150.036 162.407 150.412C162.686 150.657 162.661 150.764 162.318 150.888C157.417 152.65 152.555 154.507 147.701 156.389C147.146 156.606 146.58 156.794 146.001 157C145.987 156.78 146.132 156.773 146.22 156.716C148.163 155.505 150.043 154.191 151.951 152.923C152.686 152.436 153.411 151.936 154.135 151.431C154.577 151.126 154.584 151.044 154.17 150.675C153.004 149.638 151.828 148.615 150.658 147.589C150.591 147.532 150.52 147.475 150.46 147.411C150.294 147.241 150.351 147.131 150.559 147.06C152.852 146.285 155.096 145.376 157.364 144.542C159.495 143.757 161.619 142.944 163.742 142.134C164.604 141.807 165.456 141.456 166.315 141.122C166.502 141.047 166.693 140.966 167 141.015H166.993Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.721 137.711V140.902C126.892 135.512 181.829 135.512 198.003 140.902V137.711C181.829 132.318 126.892 132.318 110.721 137.711Z",
    fill: "#A9B6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.003 153.893C157.358 172.763 126.273 162.671 110.721 154.438V157.256L143.451 190.894H165.272L198.003 157.256V153.893Z",
    fill: "#50ABF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.706 107.117C105.181 106.629 105.665 106.147 106.153 105.67L93.6166 93.1357C93.1304 93.6129 92.6487 94.0945 92.1738 94.5829L104.708 107.117H104.706Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.018 107.117L216.552 94.5829C216.077 94.0945 215.593 93.6129 215.107 93.1357L202.57 105.67C203.061 106.145 203.543 106.626 204.018 107.117Z",
    fill: "#0086FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1408_143319",
    x: 67.4219,
    y: 68.3872,
    width: 181.877,
    height: 181.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1408_143319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1408_143319",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteeringImg);
export default __webpack_public_path__ + "static/media/steering-img.b0a3809c7990ad38cad77a9d4ba02837.svg";
export { ForwardRef as ReactComponent };